<template>
  <div></div>
</template>

<script>
import wx from "weixin-jsapi";

export default {
  data() {
    return {};
  },
  watch: {
    $route() {
      //this.loadwx();
    }
  },
  created() {
    this.loadwx();
  },
  methods: {
    loadwx() {
      console.log("路由变化!!!!1111111111111111");
      //加载站点信息
      let signUrl = window.location.href.split("#")[0];
      let tit = document.title;
      let pic = this.$WEB.$STORE.state.Image;

      //微信才走这个模式
      if (sessionStorage.getItem("laiyuan") == "wx") {
        this.$AJAX.posturl2("/api/wx/JSSDK", { pageurl: signUrl }).then(ret => {
          let data = ret.data.response;

          //   alert(
          //     `data.appid-${data.appid},data.timestamp-${data.timestamp},data.noncestr-${data.noncestr},data.signature-${data.signature},pic-${pic}`
          //   );

          wx.config({
            //debug: true,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
          });

          wx.ready(function() {
            //分享到朋友圈
            wx.onMenuShareTimeline({
              title: tit, // 分享时的标题
              link: `http://${location.host}/#/shouye`, // 分享时的链接
              imgUrl: pic, // 分享时的图标
              success: function() {
                console.log("分享成功");
              },
              cancel: function() {
                console.log("取消分享");
              }
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
              title: tit,
              desc: "商务印刷实时报价，赶快体验吧!",
              link: `http://${location.host}/#/shouye`, // 分享时的链接
              imgUrl: pic,
              type: "",
              dataUrl: "",
              success: function() {
                console.log("分享成功");
              },
              cancel: function() {
                console.log("取消分享");
              }
            });
          });

          wx.error(function(res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，
            // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
            // 对于SPA可以在这里更新签名。
            alert("失败:" + JSON.stringify(res));
          });
        });
      }
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/chanpin/components/sharewx.vue